import events from 'lib/events';
import moment from 'moment';
import Pagination from 'components/layout/pagination';
import PrintableReport from '../../components/printableReport';
import React from 'react';
import ReportApi from 'api/report';
import {dateTimeFormats} from 'helpers/constants';
import {formatCurrency} from 'helpers/currencyHelper';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class MissedProductSalesSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};

  // TODO: i18n
  getDateRange = () => {
    let {formatMessage, locale} = this.props.intl;
    let dateFrom = moment(this.props.filters.dateFrom).format(dateTimeFormats.numeralDate);
    let dateTo = moment(this.props.filters.dateTo).format(dateTimeFormats.numeralDate);

    return dateFrom + ' to ' + dateTo;
  };

  export = () => {
    let filters = this.props.filters;

    ReportApi.getMissedProductSalesReportExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.branch,
      filters.categoryType
    );
  };

  printReport = () => {
    const {fullReport, filters} = this.props;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'general.product.name'}), key: 'ProductName'},
      {name: formatMessage({id: 'general.product.category'}), key: 'ProductCategory'},
      {name: formatMessage({id: 'general.volume.recommended'}), key: 'VolumeRecomended'},
      {name: formatMessage({id: 'general.volume.purchased'}), key: 'VolumePurchased'},
      {name: formatMessage({id: 'general.missed.volume.purchased'}), key: 'Volume'},
    ];

    return <PrintableReport
      report={fullReport}
      columns={columns}
      start={moment(filters.dateFrom).format(dateTimeFormats.numeralDate)}
      startLabel={formatMessage({id: 'general.start.date'})}
      end={moment(filters.dateTo).format(dateTimeFormats.numeralDate)}
      endLabel={formatMessage({id: 'general.end.date'})}
      title={formatMessage({id: 'reports.missed.product.sales'})}/>;
  };

  render() {
    const {count, total, page, onPageChange, report, showNoDataMessage} = this.props;
    let tableRows;
    let tableTitle;
    let data = report;

    if (data && Object.keys(data).length) {
      tableRows = data.map((row, i) =>
        <tr key={i}
            className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td>{row.ProductName}</td>
          <td>{row.ProductCategory}</td>
          <td>{row.VolumeRecomended}</td>
          <td>{row.VolumePurchased}</td>
          <td>{row.Volume}</td>
        </tr>
      );
    }
    return <div>
      <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <span className={this.props.filters ?
          'summary-date' :
          'not-show'}> | <FormattedMessage id="reports.report.summary"/>: {this.getDateRange()}
        </span>
        <br/>
        <span><FormattedMessage id="reports.reveal.report.summary"/></span>
        {showNoDataMessage ?
          <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
        <div className="container-fluid custom-container-margins">
          <div className={data && Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            <table className="summary-table">
              <tbody>
                <tr className="table-title">
                  <th className="bigger-row"><FormattedMessage id="general.product.name"/></th>
                  <th><FormattedMessage id="general.product.category"/></th>
                  <th><FormattedMessage id="general.volume.recommended"/></th>
                  <th><FormattedMessage id="general.volume.purchased"/></th>
                  <th><FormattedMessage id="general.missed.volume.purchased"/></th>
                </tr>
                {tableRows}
              </tbody>
            </table>
            <div className='center-pagination'>
              <Pagination
                onPageChange={onPageChange}
                page={page}
                count={count}
                total={total}/>
            </div>
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group'>
        <button className='btn btn-default pull-right'
                disabled={Object.keys(data).length <= 0}
                onClick={() => {
                  events.publish('print', this.printReport(report));
                }}><FormattedMessage id="reports.print.summary"/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

export default injectIntl(MissedProductSalesSummary);
